var _circle, _circle2, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOrangeMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#FFE9A6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 23,
    fill: "#FFCA64"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1634_179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.0293 20.3776L23.9377 32.4684C23.8564 32.55 23.7598 32.6147 23.6534 32.6589C23.547 32.7031 23.4329 32.7259 23.3177 32.7259C23.2025 32.7259 23.0885 32.7031 22.9821 32.6589C22.8757 32.6147 22.7791 32.55 22.6978 32.4684L18.0218 27.788C17.9405 27.7064 17.8439 27.6416 17.7375 27.5974C17.6311 27.5532 17.5171 27.5305 17.4019 27.5305C17.2867 27.5305 17.1726 27.5532 17.0662 27.5974C16.9598 27.6416 16.8632 27.7064 16.7819 27.788C16.7003 27.8693 16.6355 27.9659 16.5914 28.0723C16.5472 28.1787 16.5244 28.2927 16.5244 28.4079C16.5244 28.5231 16.5472 28.6372 16.5914 28.7436C16.6355 28.85 16.7003 28.9466 16.7819 29.0279L21.4597 33.7047C21.9531 34.1973 22.6218 34.4739 23.319 34.4739C24.0162 34.4739 24.685 34.1973 25.1784 33.7047L37.2692 21.6166C37.3507 21.5353 37.4153 21.4388 37.4594 21.3325C37.5035 21.2262 37.5262 21.1122 37.5262 20.9971C37.5262 20.882 37.5035 20.7681 37.4594 20.6618C37.4153 20.5555 37.3507 20.4589 37.2692 20.3776C37.1879 20.296 37.0913 20.2312 36.9849 20.1871C36.8785 20.1429 36.7644 20.1201 36.6492 20.1201C36.534 20.1201 36.42 20.1429 36.3136 20.1871C36.2072 20.2312 36.1106 20.296 36.0293 20.3776Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1634_179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(16.5 16.5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeMark);
export default __webpack_public_path__ + "static/media/orange-mark.66c015f7ac29e34137051046f61bdd49.svg";
export { ForwardRef as ReactComponent };